module.exports = __webpack_public_path__ + "img/loginBG3.bf38a90e.png";